import React from 'react'
import { FaRegShareFromSquare } from 'react-icons/fa6';
import ShopTitle from './ShopTitle';

type ShopHeaderProps = {
  handleOpenShareModal: () => void;
  webshopError: boolean;
  teamMemberData: any;
  teamData: any;
  associationData: any;
  salesStartDate?: string | null;
  salesEndDate?: string | null;
  bookletsLength: number;
}

const ShopHeader: React.FC<ShopHeaderProps> = ({
  handleOpenShareModal,
  webshopError,
  teamMemberData,
  teamData,
  associationData,
  salesStartDate,
  salesEndDate,
  bookletsLength
}) => {
  // Determine if we should show the inactive state
  const now = new Date();
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const endDate = salesEndDate ? new Date(salesEndDate) : null;
  if (endDate) {
    endDate.setHours(0, 0, 0, 0);
  }

  const isAfterSalesEnd = endDate && today > endDate;
  const shouldShowInactiveState = webshopError || bookletsLength === 0 || isAfterSalesEnd;

  // For visual appearance: webshop should look "active" even before sales start
  // Only show as inactive if there's an error, no booklets, or AFTER sales end
  const isVisuallyActive = !shouldShowInactiveState;

  return (
    <div className={`header ${shouldShowInactiveState ? 'sales-inactive' : ''}`}>
      <div className="relative container">
        {isVisuallyActive && bookletsLength > 0 &&
          <button onClick={handleOpenShareModal} className='btn-share-webshop flex items-center'>
            <FaRegShareFromSquare />
            Dela webbshop
          </button>
        }
        <svg width={isVisuallyActive ? '50' : '35'} height={isVisuallyActive ? '48.75' : '35'} viewBox="0 0 20 18.75">
          <path
            id="shop"
            d="M3.712,1.438A1.25,1.25,0,0,1,4.662,1H15.338a1.25,1.25,0,0,1,.95.438l3.261,3.8A1.875,1.875,0,0,1,20,6.463v.319A2.969,2.969,0,0,1,14.688,8.6,2.969,2.969,0,0,1,10,8.6a2.969,2.969,0,0,1-4.687,0A2.969,2.969,0,0,1,0,6.781V6.463a1.875,1.875,0,0,1,.451-1.22L3.714,1.436ZM5.937,6.781a1.719,1.719,0,1,0,3.438,0,.625.625,0,1,1,1.25,0,1.719,1.719,0,1,0,3.438,0,.625.625,0,0,1,1.25,0,1.719,1.719,0,1,0,3.438,0V6.463a.625.625,0,0,0-.15-.406L15.338,2.25H4.662L1.4,6.056a.625.625,0,0,0-.15.406v.319a1.719,1.719,0,1,0,3.438,0,.625.625,0,0,1,1.25,0ZM1.875,10.375A.625.625,0,0,1,2.5,11v7.5H3.75V12.25A1.25,1.25,0,0,1,5,11H8.75A1.25,1.25,0,0,1,10,12.25V18.5h7.5V11a.625.625,0,1,1,1.25,0v7.5h.625a.625.625,0,1,1,0,1.25H.625a.625.625,0,1,1,0-1.25H1.25V11A.625.625,0,0,1,1.875,10.375ZM5,18.5H8.75V12.25H5Zm6.25-6.25A1.25,1.25,0,0,1,12.5,11H15a1.25,1.25,0,0,1,1.25,1.25V16A1.25,1.25,0,0,1,15,17.25H12.5A1.25,1.25,0,0,1,11.25,16Zm3.75,0H12.5V16H15Z"
            fill="#222"
          />
        </svg>
        {!webshopError
          ? <div className={`flex flex-col mb`}>
            <ShopTitle
              teamMemberData={teamMemberData}
              teamData={teamData}
              associationData={associationData}
              salesStartDate={salesStartDate}
              salesEndDate={salesEndDate}
              bookletsLength={bookletsLength}
            />
          </div>
          : <h1>Hittade ingen webbshop</h1>
        }
      </div>
    </div>
  )
}

export default ShopHeader
